import React from 'react';
import TabAmount from '@tools/ui/components/common/layout/TabAmount';
import {
  EnumGenericTaskType,
  FilterFindManyGenericTaskInput
} from '@tools/ui/types/generated/graphql';
import { useTaskCount } from '../../components/common/generic-inbox/hooks/useTaskCount.hook';

type TProps = {
  queryVerificationTasksArgs: FilterFindManyGenericTaskInput;
};

const BusyTabAmount: React.FC<TProps> = ({ queryVerificationTasksArgs }) => {
  const verificationTaskCount = useTaskCount({
    baseFilters: queryVerificationTasksArgs,
    inboxType: EnumGenericTaskType.busy
  });

  return <TabAmount amount={verificationTaskCount || 0} />;
};

export default React.memo(BusyTabAmount);
